import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useTranslation } from 'react-i18next';

const Navigation = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const location = useLocation();
  const { t, i18n } = useTranslation();

  const navLinks = [
    { key: 'home', path: '/' },
    { key: 'about', path: '/about' },
    { key: 'services', path: '/services' },
    { key: 'gallery', path: '/gallery' },
    { key: 'blog', path: '/blog' },
    { key: 'careers', path: '/careers' },
    { key: 'contact', path: '/contact' }
  ];

  const switchLang = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('dsoto_lang', lng);
  };

  const scrollToContact = () => {
    if (location.pathname === '/') {
      document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/#contact';
    }
    setIsOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo-link">
          <img 
            src="https://customer-assets.emergentagent.com/job_dsoto-corporate/artifacts/tp4zyo79_D%20Soto%20Cleaning%20Logo%20Color%202.png" 
            alt="D Soto Cleaning Logo" 
            className="navbar-logo"
          />
        </Link>
        
        <div className={`nav-menu ${isOpen ? 'active' : ''}`}>
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
              onClick={() => setIsOpen(false)}
            >
              {t(`nav.${link.key}`)}
            </Link>
          ))}
          <div className="lang-switcher" data-testid="lang-switcher">
            <button
              className={`lang-btn ${i18n.language === 'en' ? 'active' : ''}`}
              onClick={() => switchLang('en')}
              data-testid="lang-en"
            >EN</button>
            <span className="lang-divider">|</span>
            <button
              className={`lang-btn ${i18n.language === 'es' ? 'active' : ''}`}
              onClick={() => switchLang('es')}
              data-testid="lang-es"
            >ES</button>
          </div>
          <Button onClick={scrollToContact} className="nav-cta-button">
            {t('nav.get_quote')}
          </Button>
        </div>

        <button className="mobile-menu-toggle" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>
    </nav>
  );
};

export default Navigation;
